import i18n, { createInstance, type i18n as I18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import {
  DEFAULT_APP_LOCALE,
  type SupportedLocale,
} from "@/lib/i18n/config";
import { flatMessageCatalogs } from "@/lib/i18n/messages";

export const resources: Record<SupportedLocale, Record<string, string>> = {
  en: flatMessageCatalogs.en,
  es: flatMessageCatalogs.es,
};

function initialize(instance: I18nInstance, preferredLocale?: SupportedLocale) {
  if (!instance.isInitialized) {
    instance.use(initReactI18next).init({
      resources: {
        en: { translation: resources.en },
        es: { translation: resources.es },
      },
      lng: preferredLocale ?? DEFAULT_APP_LOCALE,
      fallbackLng: DEFAULT_APP_LOCALE,
      initImmediate: false,
      interpolation: { escapeValue: false },
    });
  }
  return instance;
}

export function createRequestI18n(preferredLocale: SupportedLocale) {
  return initialize(createInstance(), preferredLocale);
}

export function initI18n(preferredLocale?: SupportedLocale) {
  return initialize(i18n, preferredLocale);
}

export default i18n;
